import React from 'react';
import styles from './MobileProjectCard.module.css';

function MobileProjectCard({ imageUrl = '', alt = 'Project image' }) {
  const backgroundStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};

  return (
    <div className={styles.cardMobile}>
      <div className={styles.image} style={backgroundStyle} aria-label={alt} />
    </div>
  );
}

export default MobileProjectCard;


